import React, { FC } from 'react';

import './RadioInput.scss';
import clsx from 'clsx';

interface Props {
	value: string;
	label: string;
	description?: string;
	currentValue: string;
	setCurrentValue: (value: string) => void;
	isDisabled?: boolean;
}

export const RadioInput: FC<Props> = (props) => {
	const { value, label, description, currentValue, setCurrentValue, isDisabled } = props;
	return (
		<div
			className={clsx(
				'd-flex justify-content-start align-items-center w-100 radio-input-container',
				description ? 'py-2' : 'py-5'
			)}
		>
			<input
				className="custom-radio-input"
				type="radio"
				id={value}
				name="role"
				value={value}
				checked={value === currentValue}
				onClick={(): void => setCurrentValue(value)}
				disabled={isDisabled}

			/>
			<label
				htmlFor={value}
				className={clsx(
					'd-flex flex-column align-items-start justify-content-between label-alignments',
					isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
					)}
			>
				<div className="fs-5 fw-bolder">
					{label}
				</div>
				{
					description && (
						<div className="fs-7 fw-bold text-muted">
							{description}
						</div>
					)
				}
			</label>
		</div>
	);
};
